export default "__VITE_ASSET__BfycpS86__"